// eslint-disable-next-line no-restricted-imports
import moment from "moment";

import type { KycFormFields, KycPersonFields } from "..";

const ISO_SHORT_DATE_FORMAT = "YYYY-MM-DD";
const { localDateFormat } = { localDateFormat: "YYYY-MM-DD" };

export const kycFormFieldsMap: { [k in keyof KycFormFields]: string } = {
  "company-info-reg-ein": "company_data.identity_number",
  "company-info-vat": "company_data.vat_number",
  "company-info-no-vat-number": "company_data.no_vat_number_attested",
  "company-info-reg-country": "company_data.country",
  "company-info-reg-state": "company_data.state",
  "company-info-company-name": "company_data.name",
  "company-info-company-number": "company_data.company_number",
  "company-info-company-type": "company_data.company_type",
  "company-info-company-incorporation-date": "company_data.incorporation_date",
  "company-info-company-status": "company_data.current_status",
  "company-info-company-full-address": "company_data.registered_address_in_full",
  "company-info-reg-same-address": "company_data.is_operating_address_same_as_registered_address",
  "company-info-op-address-1": "company_data.operating_address.line1",
  "company-info-op-address-2": "company_data.operating_address.line2",
  "company-info-op-state": "company_data.operating_address.state",
  "company-info-op-city": "company_data.operating_address.city",
  "company-info-op-zip": "company_data.operating_address.postal_code",
  "company-info-registered-address-1": "company_data.registered_address.line1",
  "company-info-registered-address-2": "company_data.registered_address.line2",
  "company-info-registered-state": "company_data.registered_address.state",
  "company-info-registered-city": "company_data.registered_address.city",
  "company-info-registered-zip": "company_data.registered_address.postal_code",
  "company-info-date-of-incorporation": "company_data.jurisdiction_specific_data.date_of_incorporation",
  "company-info-website": "company_data.jurisdiction_specific_data.company_website",
  "company-info-primary-account-holder": "company_data.jurisdiction_specific_data.business_contact_id",
  "associated-persons-no-ubos": "company_data.no_UBOs_attested",
  "associated-persons": "associated_persons",
};

export const kycManualFormFieldsMap: { [k in keyof KycFormFields]: string } = {
  ...kycFormFieldsMap,
  "company-info-company-name": "company_data.manually_set_registration_data.company_name",
  "company-info-company-number": "company_data.manually_set_registration_data.company_number",
};

export const kycPersonFieldsMapFunctions = {
  "person-ubo-ownership-percentage": (value) => value || undefined,
};

export const kycPersonFieldsMap: { [k in keyof KycPersonFields]?: string } = {
  "person-id": "id",
  "person-first-name": "first_name",
  "person-middle-name": "middle_name",
  "person-last-name": "last_name",
  "person-role": "role",
  "person-is-ubo": "is_UBO",
  "person-email": "email_address",
  "person-dob": "date_of_birth",
  "person-birth-country": "country_of_birth",
  "person-ssn": "ssn",
  "person-address-line1": "address.line1",
  "person-address-line2": "address.line2",
  "person-address-state": "address.state",
  "person-address-city": "address.city",
  "person-address-country": "address.country",
  "person-address-zip": "address.postal_code",
  "person-birth-city": "city_of_birth",
  "person-nationality": "nationality",
  "person-gender": "jurisdiction_specific_data.gender",
  "person-tax-residency": "jurisdiction_specific_data.tax_residency",
  "person-ubo-ownership-percentage": "jurisdiction_specific_data.ubo_ownership_percentage",
  "person-phone-number": "jurisdiction_specific_data.phone_number.number",
  "person-phone-number-region-code": "jurisdiction_specific_data.phone_number.regionCode",
};

export const kycPersonMapFunctions = {
  date_of_birth: transformDate,
};

export function transformDate(isoDate) {
  if (!isoDate) {
    return "";
  }

  return moment(isoDate, ISO_SHORT_DATE_FORMAT).format(localDateFormat);
}
